import { useMutation } from "react-query";
import { AreaComumRegrasReserva, BloqueioAntesDepoisReservaItem } from "../typings";
import http from "infra/http";

function useAreaComumSaveRegraReserva(areaComumId: string, tenantId: string | null) {
  return useMutation(
    `/v1/tenants/${tenantId}/area-comum/${areaComumId}/regras-reserva`,
    (data: Partial<Omit<AreaComumRegrasReserva, "bloqueioAntesDepoisReserva"> & {bloqueioAntesDepoisReserva?: Partial<BloqueioAntesDepoisReservaItem>}>) => {
      return http.post(`/v1/tenants/${tenantId}/area-comum/${areaComumId}/regras-reserva`, data);
    },
    { retry: false, }
  );
}

export default useAreaComumSaveRegraReserva;
